var captialize = {exports: {}};

export { captialize as __module };
